import React, { useEffect, useState } from "react";
import logger from "../../../utils/logger.ts";
import "bootstrap/js/src/dropdown";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as icon from "../../../services/icon";

import { EMPTY_MARKET_PLACE, RIGHT_ARROW } from "src/constants/images";
import GangstaCard from "components/GangstaCard/GangstaCard";
import { useWindowDimensions } from "utils/windowDimension";
import CardContainerSkeleton from "components/Loader/Skeleton/CardContainerSkeleton";
import { useQuery } from "utils/useQuery";
import { MARKET_PLACE } from "src/constants/routes";
import StatsContainer from "../statsContainer/statsContainer";
import {
  fetchMarketPlaceQuery,
  fetchMarketPlaceData,
  fetchMarketPlaceFilterData,
  setCurrentPage,
} from "../../../redux/actions/marketplace";
import { isEmpty } from "utils/isEmpty";
import Option from "./Option";
import { GrClose } from "react-icons/gr";

const CardContainer = ({
  setOptions,
  removeSearch,
  setRemovedSearch,
  handleFilter,
  sortByList,
  page,
  setPage,
  pageIndex,
  setPageIndex,
  options,
  handleItemName,
  optionRemoveHandler,
  handleAllClear,
  transactionAnalytics,
}) => {
  const {
    data,
    isLoading,
    query,
    currentPage,
    accumulatedGBETs,
    isAccumulatedGBETLoading,
  } = useSelector(({ marketplace }) => marketplace);
  const [checkWidthAdjustment, setChecWidthAdjustment] = useState({
    smallDevice: false,
    largeDevice: false,
  });

  const [activeSortElement, setActiveSortElement] = useState({
    key: Object.keys(sortByList)[0],
    value: Object.values(sortByList)[0],
  });

  const { width } = useWindowDimensions();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getGbetBalance = async (nft_id) => { };
  const [marketplaceInfo, setMarketplaceInfo] = useState(true);
  // const [accumulatedGBETs, setAccumulatedGBETs] = useState({});
  // useEffect(async () => {
  //   let list = {};
  //   await data?.tokens.map(async ({ token_id, _id }, index) => {
  //     const balance = await icon.getGbetBalance(token_id);
  //     list[token_id] = balance;
  //     setAccumulatedGBETs(list);
  //   });
  // }, [data]);

  useEffect(() => {
    if (width < 767 && !checkWidthAdjustment.smallDevice) {
      setPage({
        prev: 0,
        next: 4,
      });
      setChecWidthAdjustment({
        smallDevice: true,
        largeDevice: false,
      });
    } else if (!checkWidthAdjustment.largeDevice && width > 767) {
      setPage({
        prev: 0,
        next: 10,
      });
      setChecWidthAdjustment({
        smallDevice: false,
        largeDevice: true,
      });
    }
  }, [width]);

  const numberOfPages = () => {
    const number = data.total / 15;

    if (Number.isInteger(number)) {
      return number;
    } else {
      const num = Math.floor(number);

      return num + 1;
    }
  };

  // get query path data and set to states
  const getQueryPath = (queryPath) => {
    let optionList = [];

    if (queryPath.type) {
      optionList.push({ key: "type", value: queryPath.type[0] });
    }
    if (queryPath.level) {
      optionList.push({ key: "level", value: queryPath.level[0] });
    }

    if (queryPath.class_type) {
      optionList.push({ key: "class_type", value: queryPath.class_type[0] });
    }

    if (queryPath.attribute) {
      queryPath.attribute.map((element) => {
        optionList.push({ key: "attribute", value: element });
      });
    }
    if (queryPath.for_sale) {
      optionList.push({ key: "for_sale", value: queryPath.for_sale[0] });
    }
    if (queryPath.sort_by) {
      handleSortBy(queryPath.sort_by[0], sortByList[queryPath.sort_by[0]]);
    }

    setOptions(optionList);
  };

  useEffect(() => {
    const queryPath = useQuery(null, "from Container");
    logger.debug("Query update from sorting component", { sortByList });
    if (!queryPath) return;
    if (removeSearch) return setRemovedSearch(false);
    getQueryPath(queryPath);
    if (width < 768 && checkWidthAdjustment.smallDevice) {
      setPage({
        prev: 0,
        next: 4,
      });
    }
  }, [query]);

  useEffect(() => {
    const queryPath = useQuery(null, "from Container");
    logger.debug("Sort by list", { sortByList });
    if (queryPath.sort_by) {
      Object.entries(sortByList).map(([key, value]) => {
        if (key == queryPath.sort_by[0]) {
          setActiveSortElement({ key: key, value: value });
        }
      });
    }
    return () => {
      logger.debug("Removing path");
      dispatch(fetchMarketPlaceQuery(""));
    };
  }, []);

  const handlePagination = (pageIndex) => {
    const pathQuery = useQuery(null, "from Container");

    if (isEmpty(pathQuery)) {
      dispatch(fetchMarketPlaceData(pageIndex));
    } else {
      const path = query.replace(MARKET_PLACE.INDEX, "");

      dispatch(fetchMarketPlaceFilterData(pageIndex, path));
    }
  };

  const pageHandler = (index) => {
    if (index == "next") {
      handlePagination(pageIndex + 1);
      setPageIndex((prev) => prev + 1);
      dispatch(setCurrentPage(pageIndex + 1));
    } else {
      handlePagination(pageIndex - 1);
      setPageIndex((prev) => prev - 1);
      dispatch(setCurrentPage(pageIndex - 1));
    }
    window.scrollTo(0, 0);
  };

  const handleMobilePagination = () => {
    if (page.next > 10) {
      setPage({
        prev: 0,
        next: 4,
      });
      pageHandler("next");
    } else {
      setPage((prev) => {
        return { ...prev, next: prev.next + 4 };
      });
    }
  };

  const handleSortBy = (key, value) => {
    let path;
    const { sort_by } = useQuery(null, "from Container");
    if (currentPage !== 1) {
      dispatch(setCurrentPage(1));
      setPageIndex(1);
    }
    if (sort_by && query) {
      path = query
        .replace(`?sort_by=${activeSortElement.key}`, `?sort_by=${key}`)
        .replace(`&sort_by=${activeSortElement.key}`, `&sort_by=${key}`);
    }
    // else if (query && query != MARKET_PLACE.INDEX) {
    //   path = `${query}&sort_by=${key}`;
    // }
    else {
      path = `${MARKET_PLACE.INDEX}?sort_by=${key}`;
    }
    setActiveSortElement({
      key: key,
      value: value,
    });

    navigate(path);

    dispatch(fetchMarketPlaceQuery(path));
  };
  const Chip = ({ text, count, handleClose }) => {
    return (
      <div className="filter-chip-card">
        <div>
          {text ? text : ""}{" "}
          <span style={{ color: "grey", fontSize: "12px", marginLeft: "4px" }}>
            ({count ? count : "0"}){" "}
          </span>
        </div>
        {
          <svg
            onClick={() => {
              handleClose(text);
            }}
            xmlns="http://www.w3.org/2000/svg"
            height="18px"
            viewBox="0 0 24 24"
            width="18px"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
              fill="var(--black)"
            />
          </svg>
        }
      </div>
    );
  };
      logger.debug("Marketplace data", { data });
  return (
    <div className="card-container mt-2">
      {/* <StatsContainer transactionAnalytics={transactionAnalytics} /> */}
      {/* {marketplaceInfo && (
        <div
          class="alert me-3 p-2 d-flex justify-content-between alert-danger alert-dismissible fade show"
          role="alert"
        >
          <p>
            <strong>NOTE:</strong> Marketplace of GangstaBets has been temporarily
            disabled. Please use the{" "}
            <span
              onClick={() => {
                window.open(
                  "https://craft.network/collection/gangstabet",
                  "_blank"
                );
              }}
              className="cursor-pointer"
            >
              <u>Craft marketplace</u>
            </span>{" "}
            to buy GangstaBets.
          </p>
          <p
            onClick={() => {
              setMarketplaceInfo(false);
            }}
            className="cursor-pointer text-lg"
          >
            <GrClose />
          </p>
        </div>
      )} */}
      <h1 style={{ marginBottom: `${options.length ? "10px" : "15px"}` }}>
        MarketPlace
      </h1>

      <div className="filter-chips">
        {options.map((item, index) => (
          <Option
            key={index}
            name={handleItemName(item.value, item.key)}
            onClick={() => optionRemoveHandler(item.value, item.key)}
          />
        ))}
        {options.length ? (
          <div className="clear-all" onClick={handleAllClear}>
            Clear All
          </div>
        ) : (
          ""
        )}
      </div>
      <div>
        <div className="sort-container pb-0 d-flex justify-content-between align-items-center flex-wrap">
          <div className="title mb-2 me-3 me-xs-1 d-flex align-items-center flex-wrap">
            {data?.total < 5555 ? (
              <>
                <span className="badge total">{data?.total} </span>
                out of &nbsp;
                <span className="badge total">5555 </span>
                GangstaBets
              </>
            ) : (
              <>
                <span className="badge total">{data?.total} </span>
                GangstaBets
              </>
            )}

            <span
              className="badge rounded-pill d-block d-lg-none filter-button"
              onClick={handleFilter}
            >
              Filter
            </span>
          </div>
          <div className="sort mb-2 ">
            <div className="filter-container">
              {/* <div className="filter-text">Sort by:</div> */}
              <div
                className="al-filters dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {
                  <svg
                    width="18px"
                    height="18px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.92 8.17969H11.69H6.07999C5.11999 8.17969 4.63999 9.33969 5.31999 10.0197L10.5 15.1997C11.33 16.0297 12.68 16.0297 13.51 15.1997L15.48 13.2297L18.69 10.0197C19.36 9.33969 18.88 8.17969 17.92 8.17969Z"
                      fill="#DADADA"
                    />
                  </svg>
                }
                <div className="al-filter-selected ">
                  {activeSortElement.value}
                </div>
              </div>

              <ul class="dropdown-menu p-3" aria-labelledby="sortby">
                {Object.entries(sortByList).map(([key, value], index) => (
                  <li key={index} className="mb-1">
                    <button
                      class="dropdown-item"
                      onClick={() => handleSortBy(key, value)}
                    >
                      {value}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            {/* <p className="mb-0 me-2">Sort by:</p>
            <div class="dropdown mx-2">
              <a
                class="btn btn-link-secondary dropdown-toggle border-0"
                href="#"
                role="button"
                id="sortby"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {activeSortElement.value}
              </a>

              <ul class="dropdown-menu p-3" aria-labelledby="sortby">
                {Object.entries(sortByList).map(([key, value], index) => (
                  <li key={index} className="mb-1">
                    <button
                      class="dropdown-item"
                      onClick={() => handleSortBy(key, value)}
                    >
                      {value}
                    </button>
                  </li>
                ))}
              </ul>
            </div> */}
          </div>
          <div className="d-flex flex-wrap justify-content-between w-100"></div>
        </div>
        <div className={data?.tokens?.length != 0 && "card-list pt-1"}>
          {!isLoading ? (
            data?.tokens?.length != 0 ? (
              data?.tokens
                // .slice(0,14)
                ?.map((item, index) => (
                  <GangstaCard
                    name={item.token_name}
                    image={item.token_uri}
                    key={index}
                    stats={item.total_stats}
                    number={item.token_id}
                    class_type={item.class_type}
                    isGangster={item.isGangster}
                    accumulatedGBET={accumulatedGBETs}
                    isAccumulatedGBETLoading={isAccumulatedGBETLoading}
                    type={item.type}
                    data={item.skills}
                    id={item._id}
                    for_sale={item.for_sale}
                    fromMarketPlace={true}
                    selling_price={item.selling_price}
                  />
                ))
            ) : (
              <div className="text-center align-self-center py-5">
                <img src={EMPTY_MARKET_PLACE.SOURCE} alt="empty market-place" />
                <h3 className="mb-1 title">No GangstaBets!</h3>
                <p className="mb-1 no-data">
                  Please try again with search combination.
                </p>
              </div>
            )
          ) : (
            <CardContainerSkeleton />
          )}
        </div>
      </div>
      {data?.total > 15 && (
        <div className="pagination d-md-flex justify-content-end pt-4">
          <button
            onClick={() => pageHandler("prev")}
            className="btn btn-outline-secondary mx-4"
            disabled={pageIndex <= 1}
          >
            <img
              src={RIGHT_ARROW.SOURCE}
              alt="previous page"
              className="previous-page mb-1"
            />
          </button>
          <p className="mb-1 text-center">
            {/* <input type="text" placeholder="1" style={{width:"inherit",height:"inherit",padding:"5px 5px",textAlign:"center !important",outline:"none !important",color:"var(--black)",fontSize:"14px",background:"var(--text-filter-background) !important"}}/> */}
            Page{" "}
            <span
              style={{
                margin: "5px",
                background: "var(--text-field-background) !important",
                padding: "12px 20px !important",
              }}
            >
              {currentPage}
            </span>{" "}
            of {numberOfPages()}
          </p>
          <button
            className="btn btn-outline-secondary mx-4"
            onClick={() => pageHandler("next")}
            disabled={pageIndex >= numberOfPages()}
          >
            <img
              src={RIGHT_ARROW.SOURCE}
              alt="next page"
              className="next-page mb-1"
            />
          </button>
        </div>
      )}
      {page.next < data.total !== 0 &&
        data.length &&
        (pageIndex < numberOfPages() || page.next < 10) && (
          <div className="d-flex justify-content-center d-md-none pt-4">
            <button
              className="btn btn-primary px-3 py-2"
              onClick={handleMobilePagination}
            >
              {page.next < 10 ? "Load more..." : "Next Page"}
            </button>
          </div>
        )}
    </div>
  );
};

export default CardContainer;
